import { render, staticRenderFns } from "./global-score-modal.vue?vue&type=template&id=0effa67d&scoped=true&"
import script from "./global-score-modal.vue?vue&type=script&lang=js&"
export * from "./global-score-modal.vue?vue&type=script&lang=js&"
import style0 from "./global-score-modal.vue?vue&type=style&index=0&id=0effa67d&lang=scss&scoped=true&"
import style1 from "./global-score-modal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0effa67d",
  null
  
)

export default component.exports